import { MoneTracker } from 'Services/MoneTracker';

type TrackAuthorStatusChangeT = {
  action: string;
  source?: string;
  slug: string;
  authorId: string;
  type?: string;
};

export const trackAuthorFollowingStatusChange = ({
  action,
  source,
  type = 'author',
  slug,
  authorId,
}: TrackAuthorStatusChangeT) => {
  return MoneTracker.trackEvent({
    action,
    source,
    type,
    data: {
      author_id: authorId,
      author_slug: slug,
    },
  });
};
